<template>
  <div id="keycard-select-view">
    <div class="flex-grow">
      <keycard-accordion @keycard="setKeycard" />
    </div>
    <div class="bottom sticky-bottom">
      <ria-button class="uppercase" :text="$t('participants.confirm')" :fullwidth="true" :active="!!keycard" :action="confirmKeycard" />
    </div>
  </div>
</template>

<script>
  import KeycardAccordion from "../components/form/elements/keycard-accordion";
  import RiaButton from "../components/common/ria-button"
  import { mapGetters } from 'vuex';
  import {keepScroll} from "../mixins";

  export default {
    name: "Keycard",
    mixins: [keepScroll],
    components: {
      KeycardAccordion, RiaButton
    },
    data: function() {
      return {
        keycard: null
      }
    },
    methods: {
      setKeycard: function(keycard) {
        this.keycard = keycard
      },
      confirmKeycard: function() {
        this. unselectKeyCardIfAlreadyUsedOne();

        this.$store.commit('customer/SET_KEYCARD_SELECTION',this.keycard);

        this.$store.commit('order/SET_DETAIL_FIELD', {
          index: parseInt(this.$route.params.participantIndex),
          field: 'keycard',
          value: this.keycard
        })

        this.$router.push({ name: 'Participants' })
      },
      unselectKeyCardIfAlreadyUsedOne: function(){
        const keycardNumber = this.details[this.$route.params.participantIndex].keycard.number;
        if( keycardNumber !== undefined){
          this.$store.commit('customer/SET_KEYCARD_SELECTION',{number:keycardNumber,unselected:true});
        }
      }
    },
    computed: {
      ...mapGetters('order',["details"]),
    }
  };
</script>

<style scoped>
  .bottom {
    @apply w-full py-3.5 px-5 flex justify-between items-center bg-white z-5 border-t-1 border-grey-border;
  }

  #keycard-select-view {
    @apply flex flex-grow flex-col min-h-screen;
  }

  @screen lg {
    #keycard-select-view {
      @apply block min-h-0;
    }

    .bottom {
      @apply relative;
    }
  }

</style>
